import {wmsHttp} from '@/utils/http/index.js'

/**
 * 批量接收oms下盘点计划单
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/52330
 */
export function batchSaveCountPlanFormOms(data) {
    return wmsHttp.post(
        '/warehouse_management_system/external_supplier_order/batch_save/count_plan/from_oms',
        data
    )
}

/**
 * 根据批属性和批次获取可用库存
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/16129
 */
export function getAvailableAmountByAttrs(data) {
    return wmsHttp.post(
        '/warehouse_management_system/batch_attribute/appoint',
        data
    )
}


/**
 * oms查询盘点计划单详情-单据信息
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/52328
 */
export function externalInitiationOrderDetail(data) {
    return wmsHttp.post(
        '/warehouse_management_system/external_initiation_order/detail/by_oms',
        data
    )
}
